import { inject, Injectable } from '@angular/core';
import { woundtrackDefaultProcessingOptions, WoundtrackResult } from '@pixacare/domain';
import {
  fromGetWoundtrackResult,
  fromGetWoundtrackResultToPolygon,
  toWoundtrackProcessingOptionsRequest,
} from '@pixacare/dtos';
import { Point, pointsToVertices, Polygon } from '@pixacare/geometry';
import { blobToFile, fetchBlob } from '@shared/utils/utils';
import { map, Observable, switchMap } from 'rxjs';
import { WoundtrackApiService } from './api/woundtrack.api.service';

@Injectable({
  providedIn: 'root',
})
export class WoundtrackService {
  private readonly woundtrackApiService = inject(WoundtrackApiService);

  getWoundsizeResult(source: string): Observable<Polygon> {
    return fetchBlob(source).pipe(
      map((blob) => blobToFile(blob, 'woundsize.jpg')),
      switchMap((file) =>
        this.woundtrackApiService.getWoundsizeData(
          file,
          toWoundtrackProcessingOptionsRequest(woundtrackDefaultProcessingOptions),
        ),
      ),
      map((successResult) => fromGetWoundtrackResultToPolygon(successResult)),
    );
  }

  getWoundtypeResult(source: string, points: Point[]): Observable<WoundtrackResult> {
    return fetchBlob(source).pipe(
      map((blob) => blobToFile(blob, 'woundsize.jpg')),
      switchMap((file) => this.woundtrackApiService.getWoundtypeData(file, pointsToVertices(points))),
      map((successResult) => fromGetWoundtrackResult(successResult)),
    );
  }
}
